import classNames from 'classnames';
import { FC } from 'react';

type SwitchProps = {
  enabled?: boolean;
  onClick: () => void;
};

const Switch: FC<SwitchProps> = ({ enabled = false, onClick }) => {
  const classes = classNames(
    'transition duration-300 rounded-full p-[2px] flex border-2 h-6',
    enabled ? 'bg-blue border-transparent' : 'border-grey-700'
  );
  const indicatorClasses = classNames(
    'transition ease-bounce duration-300 h-[0.8em] mr-[1em] rounded-full aspect-square h-full',
    enabled && 'translate-x-[1em]',
    enabled ? 'bg-white' : 'bg-grey-700'
  );

  return (
    <button
      className={classes}
      onClick={onClick}
      role="switch"
      aria-checked={enabled}
      aria-label="switch"
    >
      <div className={indicatorClasses}></div>
    </button>
  );
};

export default Switch;
